import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  // Mantemos rotas específicas, mas o menu principal abre a página de serviços
  const services = [
    { name: "Todos os Serviços", path: "/servicos" },
  ];

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

return (
  <header className="bg-white/90 backdrop-blur-md shadow-md sticky top-0 z-50 w-full">
    <div className="max-w-7xl mx-auto flex items-center justify-between h-20 px-6 lg:px-12">
      {/* 🟦 Logo */}
      <Link to="/" className="flex items-center shrink-0">
        <img
          src="/logoInvictus.webp"
          onError={(e) => (e.currentTarget.src = "/logoInvictus.png")}
          alt="Logotipo da INVICTUS Tecnologia"
          className="h-14 object-contain hover:scale-105 transition-transform duration-300"
        />
      </Link>

      {/* 🟦 Menu Desktop */}
      <nav className="hidden lg:flex flex-1 justify-center items-center gap-10">
        <Link
          to="/"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/") ? 'page' : undefined}
        >
          Início
        </Link>

        <Link
          to="/sobre"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/sobre") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/sobre") ? 'page' : undefined}
        >
          A Empresa
        </Link>

        <Link
          to="/solucoes"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/solucoes") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/solucoes") ? 'page' : undefined}
        >
          Soluções
        </Link>

        <Link
          to="/infraestrutura"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/infraestrutura") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/infraestrutura") ? 'page' : undefined}
        >
          Infraestrutura
        </Link>

        <Link
          to="/recursos"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/recursos") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/recursos") ? 'page' : undefined}
        >
          Recursos
        </Link>

        <Link
          to="/servicos"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/servicos") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/servicos") ? 'page' : undefined}
        >
          Serviços
        </Link>

        <Link
          to="/area-cliente"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/area-cliente") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/area-cliente") ? 'page' : undefined}
        >
          Área do Cliente
        </Link>

        <Link
          to="/planos"
          className={`font-medium text-base hover:text-blue-600 transition-all ${
            isActive("/planos") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-current={isActive("/planos") ? 'page' : undefined}
        >
          Planos
        </Link>
      </nav>

      {/* 🟦 Botão Desktop */}
      <div className="hidden lg:flex">
        <Link
          to="/contato"
          className="bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-700 transition-all shadow hover:shadow-lg"
        >
          Falar com Especialista
        </Link>
      </div>

      {/* 🟦 Botão Mobile */}
      <button
        className="lg:hidden text-gray-700 text-3xl hover:text-blue-600 transition-all"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Abrir menu"
      >
        <i
          className={`${
            isMenuOpen ? "ri-close-line" : "ri-menu-line"
          } transition-transform duration-300`}
        ></i>
      </button>
    </div>

    {/* 🟦 Menu Mobile */}
    {isMenuOpen && (
      <div className="lg:hidden py-4 border-t animate-slideDown bg-white">
        <nav className="flex flex-col space-y-3 px-8">
          {[
            { name: "Início", path: "/" },
            { name: "A Empresa", path: "/sobre" },
            { name: "Soluções", path: "/solucoes" },
            { name: "Infraestrutura", path: "/infraestrutura" },
            { name: "Recursos", path: "/recursos" },
            { name: "Área do Cliente", path: "/area-cliente" },
            { name: "Planos", path: "/planos" },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsMenuOpen(false)}
              className={`px-2 py-2 font-medium hover:text-blue-600 transition-colors ${
                isActive(item.path) ? "text-blue-600" : "text-gray-700"
              }`}
              aria-current={isActive(item.path) ? 'page' : undefined}
            >
              {item.name}
            </Link>
          ))}

          {/* Submenu Serviços Mobile */}
          <div className="px-2 py-2">
            <span className="font-medium text-gray-700 text-base">Serviços</span>
            <div className="ml-4 mt-2 flex flex-col space-y-1">
              {services.map((service) => (
                <Link
                  key={service.path}
                  to={service.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-sm py-1 transition-colors ${
                    isActive(service.path)
                      ? "text-blue-600 font-semibold"
                      : "text-gray-700 hover:text-blue-600"
                  }`}
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/contato"
            onClick={() => setIsMenuOpen(false)}
            className="bg-blue-600 text-white font-semibold px-4 py-2 rounded-lg text-center hover:bg-blue-700 transition-all mt-2"
          >
            Falar com Especialista
          </Link>
        </nav>
      </div>
    )}
  </header>
);

};

export default Header;
